module.exports = __webpack_public_path__ + "static/48x48-b624f6c63cb4cb6a39d780a24d7fa297.png";